import { panel_key, PanelsKeys } from '../panels/types';
import { DefaultTabKey } from '../tab/types';
import { UIGroup } from 'z3k-config';
import { sortByUISettings } from './utils';
import { removeNulls } from 'utils';
const default_device_ui_settings_icons = {};
const default_panel_ui_setting = {};
export const getDefaultDeviceUiSettings = (z3k_config) => {
    const custom_tabs = Object.fromEntries(UIGroup.get
        .all(z3k_config)
        .map((ui_group) => [
        `${DefaultTabKey.custom_tab}-${ui_group.id}`,
        default_panel_ui_setting,
    ]));
    const default_ui_settigns = {
        ...custom_tabs,
        [DefaultTabKey.heat_tab]: default_panel_ui_setting,
        [DefaultTabKey.control_tab]: default_panel_ui_setting,
        [DefaultTabKey.guard_tab]: default_panel_ui_setting,
        [DefaultTabKey.dashboard]: default_panel_ui_setting,
        icons: {
            heating_modes: default_device_ui_settings_icons,
            heating_circuits: default_device_ui_settings_icons,
        },
    };
    return default_ui_settigns;
};
function getPanelInternalOrder(cards, internal_order, is_support) {
    const cards_order = cards.map(({ id }, index) => {
        const card_ui_settings = is_support
            ? { position: index, show: true }
            : internal_order?.[id] ?? { position: index, show: true };
        const { position, show } = card_ui_settings;
        return [
            id,
            {
                position,
                show,
            },
        ];
    });
    return Object.fromEntries(cards_order);
}
const entities_height = (length) => ({
    [PanelsKeys.heating_circuits]: length > 6 ? 15 : 8,
    [PanelsKeys.boiler_heating_circuits]: length > 6 ? 14 : 7,
    [PanelsKeys.thermometers]: length > 6 ? 10 : 6,
    [PanelsKeys.heating_modes]: length > 7 ? 12 : 6,
    [PanelsKeys.boiler_heating_modes]: length > 7 ? 12 : 6,
    [PanelsKeys.sensors]: length > 6 ? 10 : 6,
    [PanelsKeys.custom_controls]: length > 6 ? 10 : 6,
    [PanelsKeys.guard_control]: length > 6 ? 10 : 6,
    [PanelsKeys.guard_zones]: length > 2 ? 14 : 6,
    [PanelsKeys.simple_view]: 0,
    [PanelsKeys.rf_indicators]: 0,
    [PanelsKeys.vehicle_custom_controls]: 0,
    [PanelsKeys.vehicle_controls]: 0,
});
export function getDeviceUiSettings(tab_key, device_config, device_ui_settings_details, is_support) {
    const { device_ui_settings } = device_ui_settings_details;
    let default_position = -1;
    let default_y = 0;
    const panel_config = panel_key.map((key) => {
        const panel = device_ui_settings?.[tab_key]?.[key];
        const content = device_config[key];
        if (!content) {
            return null;
        }
        default_position += 1;
        const default_height = entities_height(content.length)[key];
        default_y += default_position === 0 ? 0 : default_height;
        const { x = 0, y = default_y, width = 16, height = default_height, show = true, internal_order = {}, position = default_position, } = panel || {};
        const panel_settings = {
            id: key,
            x,
            y,
            height,
            width,
            show: key === PanelsKeys.vehicle_controls ? true : show ?? true,
            position,
            internal_order: getPanelInternalOrder(content || [], internal_order, is_support),
        };
        return [key, panel_settings];
    });
    const tab_settings = Object.fromEntries(removeNulls(panel_config));
    //Пройдём по всем веткам
    return {
        ...device_ui_settings,
        [tab_key]: tab_settings,
        icons: {
            ...device_ui_settings?.icons,
            heating_circuits: device_ui_settings?.icons?.heating_circuits ||
                default_device_ui_settings_icons,
            heating_modes: device_ui_settings?.icons?.heating_modes ||
                default_device_ui_settings_icons,
        },
    };
}
export function applyUiSettingsOrder(cards, internal_order, icon, hidden_name) {
    const cards_ui_settings = cards.map((card) => {
        const ui_settings = {
            ...internal_order[card.id],
            icon: icon[card.id],
            hidden_name: hidden_name[card.id],
        };
        return {
            ...card,
            ui_settings,
        };
    });
    return cards_ui_settings.sort(sortByUISettings('position'));
}
export function applyFilterUiSettings(items, should_filter) {
    if (should_filter) {
        return items.filter((item) => item.ui_settings.show);
    }
    return items;
}
